export default __webpack_public_path__ + "static/gs-2b-reviewgeneratedcode--mobile-021018e985ef85c5fc4a7a260b64aadb.webp";